<template>
  <div>
    <Navbar v-if="$route.name == 'invoicereport'"/>
    <!-- <Breadcrumb v-if="$route.name == 'invoicereport'" /> -->
    <div v-show="invoice_id==0">
      <!-- Filters Row -->
      <div class="row col-12 px-0 mt-3 mb-3">
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <!-- Bulk Action -->
          <select
            v-model="bulkaction"
            class="form-select form-select-sm"
            style="width: 110px;"
          >
            <option value="0">Bulk action</option>
            <option v-show="selectcount != 0" value="2">
              Export selected to Excel
            </option>
            <option v-show="invoices.length > 0" value="3">
              Export ALL in list to Excel
            </option>
            <option v-show="invoices.length > 0" value="4">
              Export ALL in list to Excel (compact)
            </option>
          </select>

          <!-- Survey Type Filter -->
          <select
            @change="invoices_filterget"
            v-model="filtersurveytype"
            class="form-select form-select-sm"
            style="width: 100px;"
          >
            <option v-for="type in surveytypes" :key="type.value" :value="type.value">
              {{ type.text }}
            </option>
          </select>

          <!-- Payment Status Filter -->
          <select
            @change="invoices_filterget"
            v-model="filterpaymentstatus"
            class="form-select form-select-sm"
            style="width: 140px;"
          >
            <option value="0">All invoices</option>
            <option value="1">Unpaid invoices</option>
            <option value="2">Paid invoices</option>
          </select>

          <!-- Payment Method Filter -->
          <select
            @change="invoices_filterget"
            v-model="filterpaymentmethod"
            class="form-select form-select-sm"
            style="width: 140px;"
          >
            <option v-for="method in paymentmethods" :key="method.value" :value="method.value">
              {{ method.text }}
            </option>
          </select>

          <!-- Company Filter -->
          <select
            @change="invoices_filterget"
            v-model="filtercompany"
            class="form-select form-select-sm"
            style="width: 150px;"
          >
            <option v-for="company in companies" :key="company.value" :value="company.value">
              {{ company.text }}
            </option>
          </select>

          <!-- Partner Filter -->
          <select
            @change="invoices_filterget"
            v-model="filterpartner"
            class="form-select form-select-sm"
            style="width: 150px;"
          >
            <option v-for="partner in partners" :key="partner.value" :value="partner.value">
              {{ partner.text }}
            </option>
          </select>

          <!-- Date Range -->
          <span class="text-nowrap">Inv. date</span>
          <div style="width: 130px;">
            <datetime
              type="date"
              size="9"
              input-class="form-control form-control-sm"
              format="yyyy-LL-dd"
              :phrases="{ ok: 'OK', cancel: 'Cancel' }"
              v-model="start_date"
              v-on:input="invoices_filterget"
              value-zone="Europe/Stockholm"
              zone="Europe/Stockholm"
            />
          </div>
          <span>-</span>
          <div style="width: 130px;">
            <datetime
              type="date"
              size="9"
              input-class="form-control form-control-sm"
              format="yyyy-LL-dd"
              :phrases="{ ok: 'OK', cancel: 'Cancel' }"
              v-model="end_date"
              v-on:input="invoices_filterget"
              value-zone="Europe/Stockholm"
              zone="Europe/Stockholm"
            />
          </div>

          <!-- Per Page -->
          <span class="text-nowrap">per page</span>
          <select
            @change="invoices_filterget"
            v-model="perPage"
            class="form-select form-select-sm"
            style="width: 70px;"
          >
            <option v-for="option in perpageoptions" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>

      <!-- Excel Export Input -->
      <div
        v-show="bulkaction == 2 || bulkaction == 3 || bulkaction == 4"
        class="row col-12 px-0 mt-0 mb-3"
      >
        <div class="col-3">
          <div class="input-group input-group-sm">
            <input
              v-model="exportexcelfilename"
              placeholder="Enter Excel file name"
              type="text"
              autocomplete="off"
              class="form-control"
            >
            <span 
              class="input-group-text"
              :class="exportexcelfilename == '' ? 'bg-danger' : 'bg-success'"
            >
              <button class="btn btn-link btn-sm p-0" style="color: black;">
                <span
                  @click.prevent="exportexcel_save"
                  v-show="exportexcelfilename != ''"
                  class="icon-checkmark"
                ></span>
                <span
                  @click.prevent="exportexcel_cancel"
                  v-show="exportexcelfilename == ''"
                  class="icon-cross"
                ></span>
              </button>
            </span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row col-12">
        <table class="table table-hover invoicesTable" id="invoices">
          <thead>
            <tr>
              <th style="width: 50px;">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="selected"
                    :true-value="1"
                    :false-value="0"
                    @click.stop
                  >
                  <span class="text-muted" v-if="selectcount > 0">
                    ({{ selectcount }})
                  </span>
                </div>
              </th>
              <th @click="invoices_sort({sortBy: 'invoice_number', sortDesc: !orderdesc})" style="cursor: pointer;">
                Number
                <span v-if="orderby === 'invoice_number'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'invoice_date', sortDesc: !orderdesc})" style="cursor: pointer;">
                Date
                <span v-if="orderby === 'invoice_date'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'invoice_amount', sortDesc: !orderdesc})" style="cursor: pointer;">
                Amount
                <span v-if="orderby === 'invoice_amount'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'invoice_paid_amount', sortDesc: !orderdesc})" style="cursor: pointer;">
                Paid
                <span v-if="orderby === 'invoice_paid_amount'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'consultant_name', sortDesc: !orderdesc})" style="cursor: pointer;">
                Consultant
                <span v-if="orderby === 'consultant_name'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'email', sortDesc: !orderdesc})" style="cursor: pointer;">
                E-mail
                <span v-if="orderby === 'email'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
              <th @click="invoices_sort({sortBy: 'survey_name', sortDesc: !orderdesc})" style="cursor: pointer;">
                Survey
                <span v-if="orderby === 'survey_name'">{{ orderdesc ? '▼' : '▲' }}</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr 
              v-for="item in invoices" 
              :key="item.id"
              @click="invoice_edit(item)"
              style="cursor: pointer;"
            >
              <td class="align-top" style="width: 50px;">
                <div class="py-1">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="item.selected"
                      :true-value="1"
                      :false-value="0"
                      @change="countselected"
                      @click.stop
                    >
                  </div>
                </div>
              </td>
              <td>
                {{ item.invoice_number }}<br>
                <span v-if="item.invoice_reference" class="text-muted" :title="'Invoice Reference'">
                  ({{ item.invoice_reference }})
                </span>
              </td>
              <td>{{ item.invoice_date }}</td>
              <td>
                {{ item.invoice_amount_inc_vat }}<br>
                <span class="text-muted">(VAT: {{ item.invoice_vat_amount }})</span>
              </td>
              <td>
                {{ item.invoice_paid_amount }}<br>
                <span class="text-muted" :title="'Payment method'">
                  ({{ item.paymentmethod_name }})
                </span>
              </td>
              <td :class="anon ? 'g-anon' : ''">
                {{ item.consultant_name }}<br>
                <span class="text-muted">{{ item.company_name }}</span><br>
                <span class="text-muted">{{ item.partner_name }}</span>
              </td>
              <td :class="anon ? 'g-anon' : ''">
                {{ item.email }}
              </td>
              <td>
                {{ item.survey_name }}<br>
                <span v-if="item.number_members > 0" class="text-muted">
                  ({{ item.number_members }} resp.)
                </span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="mt-2 text-muted small">Loading invoices...</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <Pagination
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-label="Invoices pagination"
        @page-changed="currentPage = $event"
      />
    </div>

    <!-- Invoice Detail View -->
    <div v-show="invoice_id!=0">
      <Invoice 
        :invoiceId="invoice_id"
        v-on:invoiceClose="invoicelist_show"
        v-on:invoiceChange="invoices_get"
      />
    </div>
  </div>
</template>
<script>
import Datetime from "./CustomControls/Datetime.vue";
import Invoice from "./Invoice";
import Navbar from "./Navbar";
// import Breadcrumb from './Breadcrumb.vue';
import Pagination from './Pagination.vue';

const fields = [
  { key: "select", label: "", sortable: false, thClass: "gdq-w-50px", tdClass: "mx-0 align-top gdq-w-50px" },
  { key: "invoice_number", label: "Number", sortable: true },
  { key: "invoice_date", label: "Date", sortable: true },
  { key: "invoice_amount", label: "Amount", sortable: true },
  { key: "invoice_paid_amount", label: "Paid", sortable: true },
  { key: "consultant_name", label: "Consultant", sortable: true },
  { key: "email", label: "E-mail", sortable: true },
  { key: "survey_name", label: "Survey", sortable: true },
];

const perpageoptions = [
  { text: '10', value: 10 },
  { text: '25', value: 25 },
  { text: '100', value: 100 },
  { text: '250', value: 250 },
]

export default {
  components: {
    Datetime,
    Invoice,
    Navbar,
    // Breadcrumb,
    Pagination,
  },
  name: "InvoiceReport",
  created() {
    this.paymentmethods_get();
    this.companies_get();
    this.partners_get();
    this.surveytypes_get();
    this.dates_setdefault();
  },
  mounted() {
    this.invoices_get();
  },
  data: function () {
    return {
      exportexcelfilename: "",
      filterpaymentstatus: 0,
      start_date: null,
      end_date: null,
      invoices: [],
      allinvoices: [],
      orderby: "invoice_number",
      order: "ASC",
      orderdesc: false,
      perPage: 10,
      perpageoptions: perpageoptions,
      rows: 0,
      currentPage: 1,
      fields: fields,
      loading: false,
      selectcount: 0,
      selected: 0,
      filterpaymentmethod: 0,
      paymentmethods: [],
      filtercompany: 0,
      companies: [],
      filterpartner: 0,
      partners: [],
      bulkaction: 0,
      invoice_id: 0,
      filtersurveytype: 0,
      surveytypes: [],
    };
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
  },
  watch: {
    currentPage: function() {
      this.invoices_get();
    },
    selected: function(val) {
      this.selectall(val);
    }
  },
  methods: {
    invoicelist_show() {
      this.invoice_id = 0;
    },
    invoice_edit(item) {
      this.invoice_id=item.id;
    },
    async exportexcel_save() {
      if (this.bulkaction == 3) {
        await this.invoices_getallfiltered().then((invoices) => {
          this.$store
            .dispatch("invoices_exportexcel", { ids: invoices })
            .then((resp) => {
              var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              var filename = this.exportexcelfilename;
              fileLink.setAttribute("download", filename + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.bulkaction = 0;
            });
        });
      } else if (this.bulkaction == 4) {
        await this.invoices_getallfiltered().then((invoices) => {
          this.$store
            .dispatch("invoices_exportexcel_compact", { ids: invoices })
            .then((resp) => {
              var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              var filename = this.exportexcelfilename;
              fileLink.setAttribute("download", filename + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.bulkaction = 0;
            });
        });
      } else {
        var ids = [];
        for (var i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].selected == 1) {
            ids.push(this.invoices[i].id);
          }
        }
        var data = {
          ids: ids,
        };
        this.$store.dispatch("invoices_exportexcel", data).then((resp) => {
          var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          var filename = this.exportexcelfilename;
          fileLink.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.bulkaction = 0;
        });
      }
    },
    exportexcel_cancel() {
      this.bulkaction = 0;
      this.exportexcelfilename = "";
    },
    selectall(selected) {
      this.$nextTick(() => {      
        const setselectto = selected;
        for (var i=0;i<this.invoices.length; i++) {
            this.invoices[i].selected = setselectto;
        }
        this.countselected();
      });
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].selected == 1) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      });
    },
    surveytypes_get() {
      this.$store
        .dispatch("surveytypes_fetch")
        .then((resp) => {
          this.surveytypes = [];
          this.surveytypes.push({
            value: 0,
            text: "All types",
          });
          var surveytypes = resp.data.result;
          for (var i = 0; i < surveytypes.length; i++) {
            this.surveytypes.push({
              value: surveytypes[i].id,
              text: surveytypes[i].surveytype_name,
            });
          }
          this.surveytypes.push({
            value: 99,
            text: 'Aggregated',
          })
        });      
    },
    companies_get() {
      this.$store
        .dispatch("companies_fetch", {
          filter: "",
          start: 1,
          limit: 999999,
          orderby: "company_name",
          order: "ASC",
        })
        .then((resp) => {
          this.companies = [];
          this.companies.push({
            value: 0,
            text: "All companies",
          });
          var companies = resp.data.result;
          for (var i = 0; i < companies.length; i++) {
            this.companies.push({
              value: companies[i].id,
              text: companies[i].company_name,
            });
          }
        });
    },
    partners_get() {
      this.$store
        .dispatch("partners_fetch", {
          filter: "",
          start: 1,
          limit: 999999,
          orderby: "partner_name",
          order: "ASC",
        })
        .then((resp) => {
          this.partners = [];
          this.partners.push({
            value: 0,
            text: "All partners",
          });
          var partners = resp.data.result;
          for (var i = 0; i < partners.length; i++) {
            this.partners.push({
              value: partners[i].id,
              text: partners[i].partner_name,
            });
          }
        });
    },
    paymentmethods_get() {
      this.$store.dispatch("paymentmethods_fetch", {}).then((resp) => {
        this.paymentmethods = [];
        this.paymentmethods.push({
          value: 0,
          text: "All pay methods",
        });
        var paymentmethods = resp.data.result;
        for (var i = 0; i < paymentmethods.length; i++) {
          this.paymentmethods.push({
            value: paymentmethods[i].id,
            text: paymentmethods[i].paymentmethod_name,
          });
        }
      });
    },
    dates_setdefault() {
      var date = new Date();
      var start_date = new Date(date.getFullYear(), date.getMonth(), 1);
      this.start_date = start_date.toISOString();
      var end_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.end_date = end_date.toISOString();
    },
    invoices_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.invoices_filterget();
    },
    invoices_filterget() {
      this.currentPage = 1;
      this.invoices_get();
    },
    invoices_get() {
      this.loading = true;
      var filter = {};
      if (this.filterpaymentstatus == 1) {
        filter["invoice_paid_amount"] = {
          operator: " < ",
          value: "g_consultantinvoices.invoice_amount",
        };
      }
      if (this.filterpaymentstatus == 2) {
        filter["invoice_paid_amount"] = {
          operator: " >= ",
          value: "g_consultantinvoices.invoice_amount",
        };
      }
      var start_date = this.format_date(this.start_date);
      var end_date = this.format_date(this.end_date);
      filter["invoice_date"] = {
        operator: " BETWEEN ",
        value: "'" + start_date + "' AND '" + end_date + "'",
      };
      if (this.filterpaymentmethod != 0) {
        filter["invoice_payment_method_id"] = {
          operator: " = ",
          value: this.filterpaymentmethod,
        };
      }
      if (this.filtersurveytype == 99) {
        filter["invoice_type"] = {
          operator: " = ",
          value: "'A'",
        }
      } else {
        filter["invoice_type"] = {
          operator: " <> ",
          value: "'XYZ'",
        }
      }
      this.$store
        .dispatch("invoices_fetch", {
          start: this.currentPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: this.orderdesc == false ? "ASC" : "DESC",
          filter: filter,
          company_id: this.filtercompany,
          partner_id: this.filterpartner,
          surveytype_id: this.filtersurveytype,
        })
        .then((resp) => {
          this.invoices = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var result = resp.data.result[i];
            result.selected = 0;
            this.invoices.push(result);
          }
          this.rows = Number(resp.data.total);
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
    },
    async invoices_getallfiltered() {
      return new Promise((resolve) => {
        this.loading = true;
        var filter = {};
        if (this.filterpaymentstatus == 1) {
          filter["invoice_paid_amount"] = {
            operator: " < ",
            value: "g_consultantinvoices.invoice_amount",
          };
        }
        if (this.filterpaymentstatus == 2) {
          filter["invoice_paid_amount"] = {
            operator: " >= ",
            value: "g_consultantinvoices.invoice_amount",
          };
        }
        var start_date = this.format_date(this.start_date);
        var end_date = this.format_date(this.end_date);
        filter["invoice_date"] = {
          operator: " BETWEEN ",
          value: "'" + start_date + "' AND '" + end_date + "'",
        };
        if (this.filterpaymentmethod != 0) {
          filter["invoice_payment_method_id"] = {
            operator: " = ",
            value: this.filterpaymentmethod,
          };
        }
        if (this.filtersurveytype == 99) {
          filter["invoice_type"] = {
            operator: " = ",
            value: "'A'",
          }
        } else {
          filter["invoice_type"] = {
            operator: " <> ",
            value: "'XYZ'",
          }
        }
        this.$store
          .dispatch("invoices_fetch", {
            start: 1,
            limit: 100000,
            orderby: this.orderby,
            order: this.orderdesc == false ? "ASC" : "DESC",
            filter: filter,
            company_id: this.filtercompany,
            partner_id: this.filterpartner,
          })
          .then((resp) => {
            this.allinvoices = [];
            for (var i = 0; i < resp.data.result.length; i++) {
              var result = resp.data.result[i];
              this.allinvoices.push(result.id);
            }
            this.loading = false;
            resolve(this.allinvoices);
          }).catch(() => {
            this.loading = false;
            resolve([]);
          });
      });
    },
    format_date(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (isNaN(year)) {
        return "";
      }
      if (Number.isNaN(month)) {
        return "";
      }
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  },
};
</script>
<style>
.invoicesTable {
  font-size: 0.9rem !important;
}
</style>
